module.exports = __webpack_public_path__ + "static/media/map-marker-slash.7cf1a92a.svg";